import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../components/PageLayout';
import PageHero from '../../components/PageHero';

const BREADCRUMBS = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services/ifys-services' },
  { label: 'IFYS Services' },
];

const SERVICE_CARDS = [
  {
    title: 'Child Protection',
    to: '/services/child-protection',
    icon: (
      <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
    ),
  },
  {
    title: 'Child & Family Services',
    to: '/services/child-and-family-services',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
  {
    title: 'Housing & Accommodation',
    to: '/services/housing-and-accommodation',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
  },
  {
    title: 'Youth Services',
    to: '/services/youth-services',
    icon: (
      <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z" />
      </svg>
    ),
  },
  {
    title: 'Disability Services',
    to: '/services/disability-services',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
  {
    title: 'Social Enterprises',
    to: '/services/social-enterprises',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="6" cy="12" r="2.5" />
        <circle cx="18" cy="7" r="2.5" />
        <circle cx="18" cy="17" r="2.5" />
        <path d="M8.5 12L16 8M8.5 12L16 16" />
      </svg>
    ),
  },
];

const IfysServicesPage = () => {
  return (
    <PageLayout activeLink="services">
      <PageHero
        title="IFYS Services"
        backgroundImage="/images/service-headers/ifys_services%201.jpg"
        breadcrumbs={BREADCRUMBS}
        variant="split"
      />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-6">
          Our Work
        </h2>
        <div className="space-y-5 text-gray-700 text-base sm:text-lg leading-relaxed">
          <p>
            With a history spanning over four decades, IFYS has been actively providing a diverse
            range of specialized support and intervention programs for the well-being of children,
            young people, families, NDIS participants, and vulnerable members within our community.
          </p>
          <p>
            In collaboration with various businesses, corporations, governmental bodies, and
            charitable organisations, we deliver accommodation, child protection, disability support,
            family assistance, and youth transitional services across Queensland.
          </p>
        </div>
      </section>

      <section className="bg-gray-50 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            {SERVICE_CARDS.map((service) => (
              <Link
                key={service.title}
                to={service.to}
                className="group flex flex-col items-center justify-center py-8 px-4 rounded-2xl bg-ifys-blue text-white text-center shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-200"
              >
                <span className="mb-3 opacity-90 group-hover:opacity-100 transition-opacity">
                  {service.icon}
                </span>
                <span className="font-semibold text-sm sm:text-base leading-tight">{service.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default IfysServicesPage;
